import { CollectionData } from "./collections";
import { getCollectionImageUrl, getCloudinaryUrl } from "@/lib/cloudinary";

export const casaDelGreyDescriptionParagraphs = [
  "Casa Del Grey célèbre l'élégance méditerranéenne avec une palette audacieuse de rouges profonds et des lignes sophistiquées. Chaque pièce reflète l'opulence et la chaleur des soirées d'été dans des lieux somptueux.",
  "Les coupes impeccables et les textures riches s'unissent pour créer une esthétique à la fois intemporelle et contemporaine. Des silhouettes audacieuses, accentuées par des détails luxueux, incarnent une confiance affirmée.",
  "Cette collection est une ode à la passion et au raffinement, transformant chaque tenue en une déclaration visuelle puissante. Casa Del Grey réinvente le glamour avec une intensité captivante et une élégance sans compromis.",
];

export const casaDelGreyCollection: CollectionData = {
  id: "2022-casa-del-grey",
  title: "Casa Del Grey",
  descriptionParagraphs: casaDelGreyDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-01"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-02"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-03"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-04"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-05"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-06"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-07"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-08"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-09"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-10"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-11"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-12"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-13"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-14"),
    getCollectionImageUrl("2022-casa-del-grey", "ALEXANDRA-GREY-CASA-DEL-GREY-15"),
  ],
  date: "07/22",
  bannerImage: getCloudinaryUrl("collections-banner"),
};
